import { editPermissionsConstants, status } from '../Constants';

export function PermissionsUsers(state = {}, action: any) {
    switch (action.type) {
        case editPermissionsConstants.EDIT_PERMISSIONS_REQUEST:
            return {
                ...state,
                search_permissions_status: status.IN_PROGRESS,
                searchPermissionsList: action.data
            };
        case editPermissionsConstants.EDIT_PERMISSIONS_SUCCESS:
            return {
                ...state,
                search_permissions_status: status.SUCCESS,
                searchPermissionsList: action.data
            };
        case editPermissionsConstants.EDIT_PERMISSIONS_FAILURE:
            return {
                ...state,
                search_permissions_status: status.FAILURE,
                searchPermissionsList: null
            };
        default:
            return state;
    }
}
